export const GIT_HASH = 'debcce15'
